import { getApiKeyLogistics, getUrlVolumeApi, translate } from '../utils/util';
import * as volumeAction from '../actions/volumeAction';
import { startLoading, endLoading } from '../actions/loadingAction';
import HttpService from './HttpService';
import { enumText, showMessageToastCustom } from '../utils/util'
import { ENUMS } from '../utils/constants'

const httpService = new HttpService(getUrlVolumeApi(window), getApiKeyLogistics(window));

export default class VolumeService {
    static getMarketplaces() {
        const url = '/market';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(volumeAction.setMarketplace(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getVolumeItem(filter, callback) {
        const url = `/volumeitem`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        params: filter,
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response && response.status === 200) {
                        if (response.data.data) {
                            dispatch(volumeAction.addVolumeItems(response.data.data));
                        }
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getBlockedSerialNumber(serialNumber, callback) {
        const url = `/volumeserialnumber/blocked/${serialNumber}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response && response.status === 200 && response.data.data.items.length > 0) {
                        showMessageToastCustom(translate('warning', 'general'), 'Matrícula Bloqueada.', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getVolumeSerialNumber(serialNumber, callback) {
        const url = `/volumeserialnumber/${serialNumber}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response && response.status === 200 && response.data.data.items.length > 0) {
                        showMessageToastCustom(translate('warning', 'general'), 'Matrícula já associada a outro volume.', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getVolumeType() {
        const url = `/volumetype`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    dispatch(volumeAction.setVolumeType(response.data.data));
                    if (response.status === 200 && response.data.data) {
                        response.data.data.forEach((f) => {
                            f.description = translate(`volume:${enumText(ENUMS.eVolumeType, f.id)}`);
                        });
                        dispatch(volumeAction.setVolumeType(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static createVolume(volume, callback) {
        const url = '/volume';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, volume).then((response) => {
                    if (response.status === 200) {
                        const message = translate('volume:volume-created');
                        showMessageToastCustom(translate('sucess', 'general'), message.replace('{volumeCode}', response.data.data.code), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    let message = JSON.parse(error.response?.data?.message).data;
                    showMessageToastCustom(translate('warning', 'general'), message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static live(callback) {
        const url = '/Live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static clear() {
        return (dispatch) => {
            dispatch(volumeAction.resetVolume());
        };
    }
}